import { BreadcrumbsItem } from '@atlassian/mpac-navigation';
import { Route } from '@atlassian/mpac-ui';
import { UrlUtils } from '@atlassian/mpac-utils';
import React from 'react';
import { Switch } from 'react-router';
import { ANALYTICS_SUBJECT_ID_DISCOVER } from '../../../analytics/Events';
import { PERSPECTIVE_KEY_SEARCH } from '../../../constants/PerspectiveKey';
import { discoverAppDetailsRoute, discoverRoute, searchRoute } from '../../../constants/Routes';
import { useMountPath } from '../../AppContext';
import DiscoverAppDetailsContainer from '../containers/DiscoverAppDetailsContainer';
import DiscoverInner from './DiscoverInner';
const Discover = props => {
  const mountPath = useMountPath();
  const resolveDiscoverHref = () => UrlUtils.resolveUrlFromTemplateAndParameters({
    template: UrlUtils.transformRoutePathToUriTemplate({
      routePath: UrlUtils.joinPathNames([mountPath, discoverRoute.path])
    })
  });
  const onBreadcrumbsItemClick = e => {
    e.preventDefault();
    props.history.push({
      pathname: resolveDiscoverHref()
    });
  };
  return /*#__PURE__*/React.createElement(BreadcrumbsItem, {
    actionSubjectId: ANALYTICS_SUBJECT_ID_DISCOVER,
    onClick: onBreadcrumbsItemClick,
    href: resolveDiscoverHref(),
    text: "Marketplace apps"
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: UrlUtils.joinPathNames([mountPath, discoverRoute.path]),
    render: routeProps => /*#__PURE__*/React.createElement(DiscoverInner, {
      algoliaClient: props.algoliaClient,
      bootstrapConfig: props.bootstrapConfig,
      featureFlags: props.featureFlags,
      history: routeProps.history,
      hostConfig: props.hostConfig,
      links: props.links,
      location: routeProps.location,
      onRendered: props.onRendered,
      hostInfo: props.hostInfo,
      openAppSpecificPasswordDialog: props.openAppSpecificPasswordDialog
      // Replace with PERSPECTIVE_KEY_DISCOVER when we enable DISCOVER PERSPECTIVE
      ,
      perspectiveKey: PERSPECTIVE_KEY_SEARCH,
      locallyInstalledApps: props.locallyInstalledApps,
      globallyInstalledApps: props.globallyInstalledApps
    })
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: UrlUtils.joinPathNames([mountPath, searchRoute.path]),
    render: routeProps => /*#__PURE__*/React.createElement(DiscoverInner, {
      algoliaClient: props.algoliaClient,
      bootstrapConfig: props.bootstrapConfig,
      featureFlags: props.featureFlags,
      history: routeProps.history,
      hostConfig: props.hostConfig,
      hostInfo: props.hostInfo,
      links: props.links,
      location: routeProps.location,
      onRendered: props.onRendered,
      openAppSpecificPasswordDialog: props.openAppSpecificPasswordDialog,
      perspectiveKey: PERSPECTIVE_KEY_SEARCH,
      locallyInstalledApps: props.locallyInstalledApps,
      globallyInstalledApps: props.globallyInstalledApps
    })
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: UrlUtils.joinPathNames([mountPath, discoverAppDetailsRoute.path]),
    render: routeProps => /*#__PURE__*/React.createElement(DiscoverAppDetailsContainer, {
      appKey: routeProps.match.params.appKey,
      mpacBaseUrl: props.bootstrapConfig.mpacBaseUrl,
      atlassianCommunityBaseUrl: props.bootstrapConfig.atlassianCommunityBaseUrl,
      selectedContext: props.selectedContext,
      links: props.links,
      history: routeProps.history,
      location: routeProps.location,
      onRendered: props.onRendered,
      featureFlags: props.featureFlags
    })
  })));
};
export default Discover;